// Deciding whether a keypress in the message box means "send".
//
// An input method editor keeps a composition buffer while you type, and it
// commits that buffer with the same Enter you meant to send the message with.
// The browser reports both: one keydown while the composition is still open,
// then a second for the key itself, about thirty milliseconds apart. React has
// not re-rendered in between, so a handler that sends on both reads the same
// message text twice and posts it twice.
//
// That is what put two identical rows in the database. It only happens to
// people typing through an IME, which is why nobody using a US keyboard ever
// saw it: with Vietnamese Telex switched on, every single message was doubled.
//
// The standard signal is isComposing on the native event. keyCode 229 is the
// older form of the same thing, still what some browsers send, so both are
// checked.
export const isComposing = (event) =>
  Boolean(event?.nativeEvent?.isComposing || event?.isComposing || event?.keyCode === 229);

// Enter sends. Shift+Enter is a newline. Nothing sends while composing.
export const shouldSendOnKey = (event) =>
  !isComposing(event) && event?.code === "Enter" && event?.shiftKey !== true;

export const shouldCancelOnKey = (event) =>
  !isComposing(event) && event?.code === "Escape";
